(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-profile/assets/javascripts/views/common/navigation.js') >= 0) return;  svs.modules.push('/modules/player-profile/assets/javascripts/views/common/navigation.js');

'use strict';

svs.player_profile.views.Navigation = Marionette.View.extend({
  template(data) {
    return svs.player_profile.templates.navigation(data);
  },
  templateContext() {
    const kycActive = this.getOption('page') === 'kyc';
    return {
      page: this.getOption('page'),
      kycActive,
      profileActive: !kycActive
    };
  },
  onAttach() {
    if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      new svs.ui.ItemsMenu({
        el: 'js-profile-tabs',
        useScrollHelpers: false,
        useScrollFaders: false,
        scrollToSelected: true,
        allowToggle: false,
        showScrollbar: true,
        clickCallback: item => {
          Backbone.history.navigate(item['data-href'], {
            trigger: true,
            replace: true
          });
        }
      });
    }
  }
});

 })(window);